import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

import { CONTEXT_MENU_CELL_ID } from '@/shared/components/ui/data-table/components/ag-grid-table-core/ag-grid-table-core.constants';
import {
  TDataTablePaperProps,
  TNameContainerProps,
} from '@/shared/components/ui/data-table/data-table.types';
import { Paper } from '@/shared/components/ui/paper/paper.styled';

export const DataTablePaper = styled(Paper)<TDataTablePaperProps>`
  && {
    border-radius: ${({ theme }) => theme.shape.containerRadius};
    display: flex;
    height: 100%;
    min-height: 0;
    flex-direction: column;
    box-shadow: ${({ theme, $isInnerPage }) =>
      $isInnerPage
        ? 'none;'
        : `0 1px 0 0 ${theme.palette.stroke.secondaryLight}, // Bottom
           1px 0 0 0 ${theme.palette.stroke.secondaryLight}, // Left
           -1px 0 0 0 ${theme.palette.stroke.secondaryLight}; // Right
       `};

    .ag-cell-value {
      .custom-tag {
        align-self: flex-start;
      }
    }

    /* An icon is a flex item inside the cell, so a narrow column squeezes it --
       down to 0px below ~40px. Scoped to cells so buttons and tags are untouched. */
    .ag-cell svg {
      flex-shrink: 0;
    }

    /* ag-grid gives .ag-cell-value flex: 1 1 auto, so it fills the row height and
       the cell's own centring has nothing left to centre. */
    .ag-cell[col-id='${CONTEXT_MENU_CELL_ID}'] .ag-cell-value {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
`;

// Only the text may shrink; icon siblings keep min-width auto so the gap stays put.
export const NameCellText = styled(Typography)`
  && {
    min-width: 0;
  }
`;

export const NameContainer = styled(Box)<TNameContainerProps>`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  width: 100%;

  span {
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    span {
      text-decoration: ${({ $clickable }) =>
        $clickable ? 'underline' : 'none'};
    }
  }

  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'initial')};
`;
